export default __webpack_public_path__ + "static/media/agrihub.4c5f9d8a.png";